module.exports = __webpack_public_path__ + "static/media/logo.47e98e56.svg";